import React from "react";
import { Breadcrumbs, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ProgramLink from "./ProgramLink";
import GroupLink from "./GroupLink";

const GroupAccessories = ({ programsList }) => {
  const { t } = useTranslation();
  const { programId, groupId } = useParams();

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <ProgramLink />
        <GroupLink programId={programId} label={programsList[programId]} />
        <Typography color="textPrimary">{programsList[groupId]}</Typography>
      </Breadcrumbs>
      <Typography variant="h3" color="secondary" style={{ marginTop: 18 }}>
        {t("navigation.accessories")}
      </Typography>
    </>
  );
};

export default GroupAccessories;